/**
 * The psalter corpus, built once at module load.
 *
 * Same bargain as `data/hymnal.ts` and `data/propers.ts`: the dataset compiles into
 * THIS bundle, which is only ever fetched by someone already on a `/hymnal/*` page,
 * so the marketing site never pays for it. The psalter is ~285KB of JSON against the
 * hymnal's 469KB — a real addition to a bundle that already accepted the trade, and
 * the reason it is worth it is that this is the only one of the three corpora whose
 * FULL TEXT we may publish.
 *
 * Indexing is deterministic and pure, so building at module scope is safe in SSR and
 * in the browser alike and both produce byte-identical output, which is what keeps
 * hydration from mismatching.
 *
 * ## Two corpora, two copyrights — the reason appointments are not here
 *
 * The psalter TEXT is 1979 BCP: public domain in the United States, publishable in
 * full. The table of WHICH PSALM IS APPOINTED WHEN is not — it is
 * © 1992 Consultation on Common Texts and `data/lectionary/PROVENANCE.md` says a
 * commercial or lead-gen surface needs written permission, which this site is and
 * which we do not have. So the join is imported, wired, and fed
 * `RCL_PERMISSION_NONE`, which makes it produce nothing. See `data/appointments.ts`.
 */
import rawPsalter from '@gjl/music-manager/data/psalms/bcp_psalter.json'
import { enumeratePsalms, type PsalterSource, type RawPsalter } from '@gjl/music-manager/psalter-pages'

export const BCP_1979_PSALTER: PsalterSource = {
  id: 'bcp1979',
  label: 'The Psalter',
  translation: 'The Book of Common Prayer (1979)',
  licence: 'The text of the 1979 Book of Common Prayer is in the public domain in the United States.',
}

// `resolveJsonModule` infers a wide structural type from the 150-psalm file; the
// single annotation narrows it to the model's contract. Not a cast — the shape is
// verified by `psalter-pages.test.ts`, which runs this exact file through
// `enumeratePsalms` and asserts all 150 psalms and all 2,500 verses are present.
const corpus: RawPsalter = rawPsalter

export const psalter = enumeratePsalms(BCP_1979_PSALTER, corpus)

/** psalm number → page, for the O(1) lookup the detail route needs. */
export const psalmByNumber = new Map(psalter.psalms.map((p) => [p.number, p]))
